import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { useEffect } from "react";
import "./egi.css";
const EventsAndGetInvolved = () => {
  useEffect(() => {
    const items = document.querySelectorAll(".egi-animate");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    items.forEach((item) => observer.observe(item));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="egi-section">
      <Container>
        <Row className="g-4">
          {/* EVENTS */}
          <Col md={6} className="egi-animate">
            <Card className="egi-card events-card">
              <h4 style={{ color: "#c72800ff" }}>
                Upcoming Events & Conferences
              </h4>
              <p>
                Participate in national seminars, conferences, and professional
                gatherings organized by ICSAJ.
              </p>
              <Button className="gold-btn mt-3">View Events Calendar</Button>
            </Card>
          </Col>

          {/* GET INVOLVED */}
          <Col md={6} className="egi-animate">
            <Card className="egi-card">
              <h4 style={{ color: "#c72800ff" }}>Get Involved</h4>

              <Row className="text-center mt-4">
                <Col className="egi-item">
                  <div className="egi-icon">👥</div>
                  <p>Become a Member</p>
                </Col>

                <Col className="egi-item">
                  <div className="egi-icon">🤝</div>
                  <p>Volunteer with Us</p>
                </Col>

                <Col className="egi-item">
                  <div className="egi-icon">🏢</div>
                  <p>Partner & Support</p>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default EventsAndGetInvolved;
